import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

// import Setup from '../components/installation/Setup';
// import Reports from '../components/reports/reports';
// import Configuration from '../components/configuration/configuration';
// import Department from '../components/departments/department';
// import Customers from '../components/customers/customers';
// import Customer from '../components/customers/customer';
// import Products from '../components/products/products';
// import Product from '../components/products/product';
// import Prices from '../components/prices/prices';
// import Settings from '../components/spark/settings';
// import TeamSettings from '../components/spark/teams/team';

export const router = new VueRouter({
    mode: 'history',
    routes: [
		{
            path: '/reports',
            name: 'reports',
            component: () => import(/* webpackChunkName: "os-reports" */ '../components/reports/reports'),
            // component: Reports
        },
		{
            path: '/reports/:dashboard',
            name: 'dashboard',
            component: () => import(/* webpackChunkName: "os-reports" */ '../components/reports/reports'),
            // component: Reports
        },
		{
            path: '/customers',
            name: 'customers',
            component: () => import(/* webpackChunkName: "os-customers" */ '../components/customers/customers'),
            // component: Customers
        },
		{
            path: '/customer/:id',
            name: 'customer',
            component: () => import(/* webpackChunkName: "os-customer" */ '../components/customers/customer'),
            // component: Customer
        },
		{
            path: '/suppliers',
            name: 'suppliers',
            component: () => import(/* webpackChunkName: "os-customers" */ '../components/customers/customers'),
            // component: Customers
        },
		{
            path: '/supplier/:id',
            name: 'supplier',
            component: () => import(/* webpackChunkName: "os-customer" */ '../components/customers/customer'),
            // component: Customer
        },
		{
            path: '/products',
            name: 'products',
            component: () => import(/* webpackChunkName: "os-products" */ '../components/products/products'),
            // component: Products
        },
		{
            path: '/product/:id',
            name: 'product',
            component: () => import(/* webpackChunkName: "os-product" */ '../components/products/product'),
            // component: Product
        },
		{
            path: '/prices',
            name: 'prices',
            component: () => import(/* webpackChunkName: "os-prices" */ '../components/prices/prices'),
            // component: Prices
        },
		{
            path: '/config',
            name: 'config',
            component: () => import(/* webpackChunkName: "os-configuration" */ '../components/configuration/configuration'),
            // component: Configuration
        },
		{
            path: '/settings',
            name: 'settings',
            component: () => import(/* webpackChunkName: "os-settings" */ '../components/spark/settings'),
            // component: Settings
        },
		{
            path: '/settings/team/:id',
            name: 'teamsettings',
            component: () => import(/* webpackChunkName: "os-teamsettings" */ '../components/spark/teams/team'),
            // component: TeamSettings
        },
		{
            path: '/department/:id',
            name: 'departmemt',
            component: () => import(/* webpackChunkName: "os-department" */ '../components/departments/department'),
            // component: Department,
			props: true
        },
        {
            path: '/setup',
            name: 'setup',
            component: () => import(/* webpackChunkName: "os-setup" */ '../components/installation/Setup'),
            // component: Setup
        },
        {
            path: '/teams/missing',
            name: 'missing',
            component: () => import(/* webpackChunkName: "os-settings" */ '../components/spark/settings'),
            // component: Settings
        },
    ],
});
